// Категории клиентских тегов и порядок сортировки — единый источник
// (раньше дублировался в UsersPage и BroadcastPage)

export const TAG_CATEGORIES = {
  status: { label: 'Статусные', slugs: ['first_order', 'new', 'regular'] },
  achievement: { label: 'Достижения', slugs: ['vip', 'high_value', 'wholesale'] },
  behavioral: { label: 'Поведенческие', slugs: ['seasonal', 'inactive'] },
};

const TAG_SLUG_ORDER = Object.values(TAG_CATEGORIES).flatMap(c => c.slugs);

export const sortTags = (list) =>
  [...list].sort((a, b) => TAG_SLUG_ORDER.indexOf(a.slug) - TAG_SLUG_ORDER.indexOf(b.slug));

export const getTagCategory = (slug) => {
  for (const [key, cat] of Object.entries(TAG_CATEGORIES)) {
    if (cat.slugs.includes(slug)) return key;
  }
  return 'status';
};
